import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { NgEmptyRoutingModule } from "./ng-empty-routing.module";
import { NgEmptyComponent } from "./ng-empty.component";

@NgModule({
  imports: [
    CommonModule,
    NgEmptyRoutingModule
  ],
  declarations: [
    NgEmptyComponent
  ]
})
export class NgEmptyModule {
}
